// extracted by mini-css-extract-plugin
export default {"feed":"feed__76Okn"};